import * as React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SideMenu from './Components/Approval Ds topup/SideMenu';

const TopupDSRequest=()=>{
return(
    <MainCard  sx={{height:'80vh',overflowX:'scroll'}}>
        <SideMenu />
    </MainCard>
)
}

export default TopupDSRequest